import React from 'react'

const Autoplay1 = ({ color = '#323232' }) => {
  return (
    <svg
      version={1.0}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      className="cursor-pointer w-full h-full"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2305 4679 c-651 -82 -1231 -458 -1571 -1019 -104 -171 -194 -387
  -194 -464 0 -60 41 -137 91 -172 83 -57 219 -40 282 36 13 15 39 65 57 111 96
  241 204 404 389 590 248 247 516 393 867 471 136 30 510 33 649 5 226 -46 486
  -157 665 -284 162 -116 364 -329 460 -487 22 -36 22 -39 4 -32 -10 4 -52 17
  -92 29 -64 19 -78 20 -120 9 -60 -16 -110 -56 -140 -113 -47 -87 -12 -218 71
  -269 18 -11 177 -68 354 -127 l321 -107 58 13 c44 10 68 23 101 55 41 39 50
  58 159 356 108 293 116 319 111 369 -18 177 -236 254 -362 127 -22 -23 -47
  -61 -55 -84 l-16 -44 -53 82 c-342 525 -907 873 -1541 950 -100 12 -395 11
  -495 -1z"
        />
        <path
          d="M2262 3469 c-70 -13 -148 -54 -203 -106 -63 -59 -92 -103 -119 -182
  -19 -58 -20 -83 -20 -614 0 -600 1 -608 56 -703 31 -53 119 -136 173 -164 90
  -45 230 -61 316 -36 76 23 959 532 1022 589 116 107 162 279 114 435 -27 88
  -91 177 -162 224 -30 19 -250 147 -489 284 -505 289 -540 303 -688 273z m516
  -669 c227 -129 412 -237 412 -240 0 -4 -809 -470 -831 -478 -5 -2 -9 209 -9
  478 0 269 4 480 9 478 4 -1 193 -109 419 -238z"
        />
        <path
          d="M615 2233 c-41 -21 -74 -52 -91 -86 -8 -15 -63 -157 -122 -315 -89
  -240 -107 -296 -106 -342 1 -168 177 -263 322 -173 36 22 54 43 78 91 l31 62
  37 -59 c97 -158 266 -349 426 -483 294 -246 629 -401 1016 -469 171 -31 511
  -34 675 -6 698 117 1267 533 1579 1152 88 175 125 285 116 346 -8 57 -46 117
  -93 149 -52 35 -146 40 -208 10 -59 -28 -86 -65 -130 -176 -159 -393 -438
  -702 -805 -888 -609 -310 -1310 -240 -1845 184 -128 102 -301 297 -375 422
  l-22 37 73 -24 c40 -14 90 -25 111 -25 111 0 207 98 208 211 0 56 -40 141 -81
  170 -17 12 -170 68 -341 125 -333 111 -388 122 -453 87z"
        />
      </g>
    </svg>
  )
}

export default Autoplay1
